import { useAppStateStore } from '#/hooks/useAppStateStore';
import { useFeatureIsOn } from '#/hooks/useFeatureIsOn';

export const useCanEditSelectedReservation = (showEdit: boolean = false) => {
    const editBookingsEnabled = useFeatureIsOn('my-bookings');
    const appStore = useAppStateStore();

    return showEdit && editBookingsEnabled && appStore.isSelectedReservationEditable;
};
